module.exports = __webpack_public_path__ + "img/Piece-18-2-mobile.71107f39.png";